import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { qsStringSchema } from 'lib/zod'
import { useSnackbars } from 'settle-ui/hooks/useSnackbars/useSnackbars'
import type { Snackbar } from 'settle-ui/hooks/useSnackbarsStore/useSnackbarsStore.types'

type UrlBasedSnackbarOptions = Pick<NonNullable<Snackbar['options']>, 'permanent'>
export interface UrlBasedParams {
  warning?: string
  error?: string
  alert?: string
  info?: string
}

export const useUrlBasedSnackbar = (options?: UrlBasedSnackbarOptions) => {
  const router = useRouter()
  const { permanent } = options ?? {}
  const { showWarning, showError, showAlert, showInfo } = useSnackbars()

  useEffect(() => {
    const { warning, error, alert, info } = router.query

    if (!warning && !error && !alert && !info) {
      return
    }

    const query = { ...router.query }

    if (warning) {
      showWarning(qsStringSchema.parse(warning), { permanent, 'data-testid': 'url_based_warning' })

      delete query.warning
    }

    if (error) {
      showError(qsStringSchema.parse(error), { permanent, 'data-testid': 'url_based_error' })

      delete query.error
    }

    if (alert) {
      showAlert(qsStringSchema.parse(alert), { permanent, 'data-testid': 'url_based_alert' })

      delete query.alert
    }

    if (info) {
      showInfo(qsStringSchema.parse(info), { permanent, 'data-testid': 'url_based_info' })

      delete query.info
    }

    router.replace({ query })
  }, [router, showAlert, permanent, showInfo, showError, showWarning])
}
